<template>
    <div class="border bg-gray-100 dark:bg-gray-700 dark:text-white rounded p-4 mt-3">
        <div class="mb-4">Slider</div>
            <Select
                label="* Type"
                name="type"
                v-model="data.type"
                class="mt-3"
                :options="[
                    {value: 'Casino', name: 'Casinos'},
                    {value: 'Blacklisted Casino', name: 'Blacklisted Casinos'},
                    {value: 'Land-based Casino', name: 'Land-based Casinos'},
                    {value: 'Guide', name: 'Guides'},
                ]"
                :error="errorBag['type'] ? errorBag['type'][0] : null"
            />

            <input-text
                name="title"
                label="* Title"
                v-model="data.title"
                class="mt-3"
                lpignore
                :error="errorBag['title'] ? errorBag['title'][0] : null"
                :maxlength="255"
            />

            <input-rich-text
                label="Text"
                name="text"
                class="mt-3"
                :language="language"
                v-model="data.text"
                :maxlength="60000"
                :error="errorBag['text'] ? errorBag['text'][0] : null"
            />

            <rocket-link
                label="Link"
                :language="language"
                class="mt-3 max-w-xl"
                v-model="data.link"
                :resettable="true"
                :error="errorBag['link'] ? errorBag['link'][0] : null"
            />

            <div
                v-if="data.type && data.type != 'Casino'"
                class="border bg-white dark:bg-gray-700 rounded-lg w-full p-4 shadow-sm max-w-4xl mt-3"
            >
                <p class="text-gray-700 mb-4">* Documents</p>
                <multi-reference
                    create-text="Create new document and link document to this page"
                    link-text="Link existing documents"
                    :creatable="false"
                    :max-items="maxItems"
                    :language="language"
                    v-model="data.items"
                    :should-open-new-window="true"
                    :model-data="data.type"
                    :error="errorBag['items'] ? errorBag['items'][0] : null"
                />
            </div>

            <draggable
                v-model="data.items"
                ghost-class="bg-gray-500"
                handle=".handle"
                @choose="froalaStore.disableFroala = true"
                @unchoose="froalaStore.disableFroala = false"
                v-if="data.type && data.type == 'Casino'"
            >

                <div v-for="(item, index) in data.items" class="flex">
                    <div class="ml-4 handle mt-6 float-left text-gray-400" title="Drag to reorder items">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 17l-4 4m0 0l-4-4m4 4V3" />
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7l4-4m0 0l4 4m-4-4v18" />
                        </svg>
                    </div>
                    <div
                        @click="() => handleDelete(index)"
                        v-if="data.items?.length > minItems"
                        class="mt-12 cursor-pointer	"
                    >
                        <svg
                            class="w-4 h-4 mt-3 -ml-5"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                            />
                        </svg>
                    </div>

                    <div class="float-right mb-4 w-full ml-3">
                        <div
                            class="border bg-white dark:bg-gray-700 rounded-lg p-4 shadow-sm max-w-2xl w-[49%] float-left mt-3"
                        >
                            <p class="text-gray-700 dark:text-gray-200 mb-4">* Casino</p>
                            <reference
                                create-text="Create new casino and link casino to this page"
                                link-text="Link an existing casino"
                                :language="language"
                                v-model="item.casino"
                                model-data="Casino"
                                :should-open-new-window="true"
                                :creatable="false"
                                :query="{
                                    'casinoReview.status_id': 1
                                }"
                                :order="{
                                    'name': 'asc'
                                }"
                                @input="updateCasino($event, index)"
                            />
                        </div>

                        <div
                            class="border bg-white dark:bg-gray-700 rounded-lg p-4 shadow-sm max-w-2xl w-[49%] float-right mt-3"
                        >
                            <p class="text-gray-700 dark:text-gray-200 mb-4">* Bonus</p>
                            <reference
                                create-text="Create new bonus and link bonus to this page"
                                link-text="Link an existing bonus"
                                :language="language"
                                v-model="item.bonus"
                                model-data="Bonus"
                                :should-open-new-window="true"
                                :creatable="false"
                                :query="{
                                    'casino_id': item.casino_id
                                }"
                                :order="{
                                    'name': 'asc'
                                }"
                                @input="updateBonus($event, index)"
                            />
                        </div>
                    </div>
                </div>
                <button slot="footer"
                    class="text-indigo-600 dark:text-indigo-300 hover:text-indigo-900 dark:hover:text-indigo-200"
                    type="button"
                    v-if="data.items?.length < maxItems"
                    @click="addItem"
                >
                   + Add item
                </button>
            </draggable>
        </div>
</template>

<script>
import draggable from "vuedraggable";
import {useFroalaStore} from "../../stores/froala";

export default {
    components: { draggable },
    name: "Slider",
    props: {
        value: [Object, Array],
        language: {
            type: Object,
            default: () => {
                return { iso: siteLanguage.iso.ENGLISH };
            },
        },
        maxItems: {
            type: Number,
            default: 4,
        },
        minItems: {
            type: Number,
            default: 2,
        },
        contentBlockId: Number,
        contentSectionId: Number,
        errorBag: {
            type: [Object, Array],
            required: false,
        },
    },
    data() {
        return {
            data: {
                link: this.value?.link ?? null,
                link_id: this.value?.link_id ?? null,
                type: this.value?.type ?? null,
                title: this.value?.title ?? null,
                text: this.value?.text ?? null,
                items: this.value?.items?.length ? this.getItems() : [],
            },
            froalaStore: useFroalaStore(),
        };
    },
    methods: {
        defaultItem() {
            return {
                casino: null,
                casino_id: null,
                bonus: null,
                bonus_id: null,
            }
        },
        getItems() {
            let items = [];
            if (this.value.type == 'Casino') {
                for(let i = 0; i < this.value.items.length; i++) {
                    items[i] = {};
                    items[i]['casino'] = this.value.items[i]['document'];
                    items[i]['casino_id'] = this.value.items[i]['document']['id'];
                    items[i]['bonus'] = this.value.items[i]['bonus'];
                    items[i]['bonus_id'] = this.value.items[i]['bonus_id'];
                }
            } else {
                for(let i = 0; i < this.value.items.length; i++) {
                    items.push(this.value.items[i]['document']);
                }
            }
            return items;
        },
        addItem(e) {
            e.preventDefault();
            this.data['items'].push(this.defaultItem());
        },
        handleDelete: function (indexOfItemToDelete) {
            if (confirm('Are you sure you want to remove this item?')) {
                this.data['items'].splice(indexOfItemToDelete, 1);
            }
        },
        updateCasino: function (casino, index) {
            if (casino && casino.id) {
                this.data.items[index].casino_id = casino.id
            } else {
                this.data.items[index].casino_id = null
                this.data.items[index].bonus = null
                this.data.items[index].bonus_id = null
            }
        },
        updateBonus: function (bonus, index) {
            this.data.items[index].bonus_id = (bonus && bonus.id) ? bonus.id : null
        }
    },
    updated() {
        this.$emit("input", this.data);
    },
    watch: {
        "data.type": function (newValue) {
            if (newValue == 'Casino') {
                this.data.items = [this.defaultItem(), this.defaultItem()];
            } else {
                this.data.items = [];
            }
        },
        value: function (newValue) {
            this.data = newValue;
        },
    }
};
</script>
